module.exports = __webpack_public_path__ + "img/globe-grey.a3c18d0d.svg";